import * as Types from '@frameio/graphql-client/generated/types';

import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
import gql from 'graphql-tag';

import { useQuery, useLazyQuery, useMutation, useFragment, useSubscription } from '@apollo/client';
import type { QueryHookOptions, LazyQueryHookOptions, MutationHookOptions, SubscriptionHookOptions, UseFragmentOptions } from '@apollo/client';

export type GetLabsExperimentEnrollmentsQueryVariables = Types.Exact<{
  accountId: Types.Scalars['ID']['input'];
}>;


export type GetLabsExperimentEnrollmentsQuery = { __typename?: 'Query', account?: { __typename?: 'Account', id: string, labsExperiments?: { __typename?: 'LabsExperimentConnection', nodes: Array<{ __typename?: 'LabsExperiment', id: string, enrolled?: boolean | null, slug: string }> } | null } | null };


export const GetLabsExperimentEnrollments = /*#__PURE__*/ gql`
    query GetLabsExperimentEnrollments($accountId: ID!) {
  account(accountId: $accountId) {
    id
    labsExperiments(page: {first: 100}) {
      nodes {
        id
        enrolled
        slug
      }
    }
  }
}
    ` as unknown as DocumentNode<GetLabsExperimentEnrollmentsQuery, GetLabsExperimentEnrollmentsQueryVariables>;

          

          export const useGetLabsExperimentEnrollmentsQuery = (options?:QueryHookOptions<GetLabsExperimentEnrollmentsQuery, GetLabsExperimentEnrollmentsQueryVariables>) => useQuery(GetLabsExperimentEnrollments, options);

          

          export type GetLabsExperimentEnrollmentsQueryOptions = QueryHookOptions<GetLabsExperimentEnrollmentsQuery, GetLabsExperimentEnrollmentsQueryVariables>;

          

          export const useGetLabsExperimentEnrollmentsLazyQuery = (options?:LazyQueryHookOptions<GetLabsExperimentEnrollmentsQuery, GetLabsExperimentEnrollmentsQueryVariables>) => useLazyQuery(GetLabsExperimentEnrollments, options);

          

          export type GetLabsExperimentEnrollmentsQueryResult = ReturnType<typeof useGetLabsExperimentEnrollmentsQuery>;

          
